@if (colVm?.columnType === Types.SectionColumnProductInfoType.GradingResults) {
  <div
    class="product-column-general product-review-score"
    [style.visibility]="section?.collapseContent || rowVm?.collapseContent ? 'collapse' : ''"
    [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
    [style.margin-right]="menu | productMenuBasicMethod: 'getSectionBorderMarginSize'">
    <div class="review-score">
      <ng-container *ngIf="useNgContent"><ng-content></ng-content></ng-container>
      <ng-container *ngIf="!useNgContent">
        @if (
          rowVm | sectionRowViewModelBasicMethod: 'getGradingResultFor' : colVm?.columnConfig?.dataValue;
          as grading
        ) {
          {{ grading }}
        }
      </ng-container>
    </div>
  </div>
}
